<template>
  <div class="layoutContainer">
    <PublicNav v-if="setNav()" />
    <TopMenu v-else />
    <router-view :key="key" />
    <PublicFooter v-if="setFoter()" />

    <LoginPopup />
    <RegisterPopup />
    <ForgetPassPopup />
  </div>
</template>

<script>
import PublicNav from "./components/PublicNav.vue"
// import NavPage from "./components/NavPage.vue"
import PublicFooter from "./components/PublicFooter.vue"
import LoginPopup from "@/components/LoginPopup"
import RegisterPopup from "@/components/RegisterPopup"
import ForgetPassPopup from "@/components/ForgetPassPopup"
import TopMenu from "@/layout/components/TopMenu";
export default {
  name:"layoutContainer",
  computed: {
    key() {
      return this.$route.path
    },
  },
  components:{
    PublicNav,
    TopMenu,
    PublicFooter,
    RegisterPopup,
    LoginPopup,
    ForgetPassPopup
  },
  methods:{
    setNav(){
      let path = this.key;
      if(path=="/login" || path=="/register"){
        return true;
      }else{
        return false;
      }
    },
    setFoter(){
      let path = this.key;
      if(path=="/login" || path=="/register" || path=="/user"){
        return false;
      }else{
        return true;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/index.vue